import { render, staticRenderFns } from "./RulesDraw.vue?vue&type=template&id=2980d644&scoped=true&"
import script from "./RulesDraw.vue?vue&type=script&lang=js&"
export * from "./RulesDraw.vue?vue&type=script&lang=js&"
import style0 from "./RulesDraw.vue?vue&type=style&index=0&id=2980d644&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980d644",
  null
  
)

export default component.exports